// Vue 3 feature flags
window.__VUE_PROD_DEVTOOLS__ = false
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'

// Create and mount app
const app = createApp(App)
app.use(router)
app.mount('#app') 